<template>
  <header class="header position-rel" v-if="!hidenHeader">
    <div :class="{ 'overlay_notifi': openCollapseNoti }" @click="extoverlay"></div>
    <b-navbar toggleable="lg" class="display-flex-center justify-content-between full-width">
      <!-- <button v-b-toggle.menu_main class="d-lg-none btn-menu-mobile">
    			<span></span>
    			<span></span>
    			<span></span>
      </button>-->
      <!-- <router-link to="/" class="header__logo">
				<img src="@/assets/images/logo-nxb.png" alt="Hành trang số" />
      </router-link>-->
      <a href="javascript:;" to="/" class="header__logo" @click="directHomPage">
        <img src="@/assets/images/logo-nxb.png" alt="Hành trang số" />
      </a>
      <div class="header__right display-flex-center">
        <!-- <button type="button" class="header__search-btn secondary-color-txt font-size-26 border-0 bg-transparent">
		    		<i class="icon-search secondary-color-txt"></i>
        </button>-->
        <div id="menu_main" is-nav :class="{ 'open-menu': isMenuMobileOpen }">
          <div class="mobile__menu-head">
            <div v-if="authInfo && authInfo.email !== emailPublic"
              class="mobile__user display-flex-center full-width d-lg-none">
              <a href="javascript:;" class="primary-color-txt" @click="userProfile">
                <img class="users user-avatar border-rd-50"
                  :src="authInfo && authInfo.avatar ? `${uploadUrl}${authInfo.avatar}` : imgAvatar"
                  :alt="`${authInfo.lastName} ${authInfo.firstName}`" />
                <span class="font-sanpro-semibold">{{ authInfo.lastName }} {{ authInfo.firstName }}</span>
              </a>
            </div>
            <ul class="p-0 margin-0">
              <li class="item-primary" :class="{ 'active': subIsActive(['/ebook', '/sach-dien-tu']) }">
                <router-link :to="{ name: 'ebook', query: { book_active: 0 } }">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/book-icon.png" />
                  </figure>Sách điện tử
                </router-link>
              </li>
              <li class="item-secondary" :class="{ 'active': subIsActive('/luyen-tap') }"
                v-if="authInfo && authInfo.roleCode === roleHocSinh">
                <router-link to="/luyen-tap">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/pencil-icon.png" />
                  </figure>Luyện tập
                </router-link>
              </li>
              <li class="item-four" :class="{ 'active': subIsActive('/thu-vien') }">
                <router-link to="/thu-vien">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/library-icon.png" />
                  </figure>Thư viện
                </router-link>
              </li>
              <li class="item-five" :class="{ 'active': checkActivePrepare() }"
                v-if="authInfo && authInfo.roleCode === roleTeacher">
                <router-link to="/soan-tai-lieu">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/preparation.png" />
                  </figure>
                  Soạn tài liệu
                </router-link>
              </li>
              <li class="item-third" :class="{ 'active': checkActiveClass() }"
                v-if="authInfo && authInfo.roleCode === roleHocSinh">
                <router-link to="/danh-sach-lop-hoc">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/group_people.png" />
                  </figure>
                  Lớp học
                </router-link>
              </li>
              <li class="item-third" :class="{ 'active': checkActiveClass() }"
                v-if="authInfo && authInfo.roleCode === roleTeacher">
                <router-link to="/lop-hoc">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/group_people.png" />
                  </figure>
                  Lớp học
                </router-link>
              </li>
              <!-- <li class="item-third" :class="{ 'active': subIsActive('/danh-sach-giao-an') }"
                v-if="authInfo && authInfo.roleCode === roleTeacher">
                <router-link to="/danh-sach-giao-an">
                  <figure class="menu-img margin-0 p-0">
                    <img src="@/assets/img/class-icon.png" />
                  </figure>
                  Bài giảng
                </router-link>
              </li> -->
            </ul>
          </div>
          <div class="mobile__menu-bottom d-lg-none">
            <ul v-if="authInfo && authInfo.email !== emailPublic" class="mobile__menu-user p-0 margin-0">
              <!-- <li> -->
              <!-- <router-link to="/">Cài đặt</router-link> -->
              <!-- <a href="javascript:void(0)" class="item" @click="userProfile">Cài đặt</a> -->
              <!-- <h3 @click="userProfile">Cài đặt</h3> -->
              <!-- </li> -->
              <li>
                <router-link :to="{ name: 'under-construction' }">Trung tâm trợ giúp</router-link>
              </li>
              <li>
                <a href="javascript:;" @click="logout">Đăng xuất</a>
              </li>
            </ul>
            <ul v-else class="mobile__menu-user p-0 margin-0">
              <li v-if="!isLoginkeyCloak">
                <a href="javascript:;" @click="openLoginForm">Đăng nhập</a>
              </li>
              <li v-if="isLoginkeyCloak">
                <a href="javascript:;" @click="onLoginSSOKeyCloak">Đăng nhập SSO</a>
              </li>
              <!-- <li>
                <a href="javascript:;" v-b-modal.modalRegister>Đăng ký</a>
              </li> -->
            </ul>
          </div>
        </div>
        <div class="overlay" :class="{ 'open-menu': isMenuMobileOpen }" @click="toggleMenuMobile"></div>
        <div v-if="authInfo && authInfo.email !== emailPublic" class="header__notification">
          <!-- <a href="javascript:;" class="font-size-26 secondary-color-txt" @click="toggleCollapseNoti">
		    			<i class="icon-notification secondary-color-txt"></i>
          </a>-->
          <div class="icon-toggle" @click="toggleCollapseNoti" v-click-outside="hidenCollapseNoti"
            :class="{ 'active': openCollapseNoti }">
            <a href="javascript:;" class="font-size-26 secondary-color-txt">
              <i class="icon-notification secondary-color-txt"></i>
            </a>

            <!-- <a
                @click="nextPage"
                href="javascript:;"
                class="display-block text-center text-right primary-color font-size-15 mt-2 view-all-menu"
              >Xem tất cả</a> -->

            <span class="header__notification__dot font-sanpro-semibold" v-if="numberNotify > 0">{{ numberNotify
              }}</span>
          </div>

          <b-collapse id="alert_notification" class="collapse" :visible="openCollapseNoti">
            <template v-if="notificationData && notificationData.length > 0">
              <vue-custom-scrollbar class="header__notification__collaspe">
                <div class="item display-flex" v-for="(item, index) of notificationData" :key="`noti_${index}`"
                  @click="showInfoNoti(item, index)" :class="{ 'background-isRead': !item.isRead }">
                  <!-- <img src="@/assets/img/HS-2.jpg" alt="">
                  :src="items.avatar != null ? appUrl + items.avatar : thumbUrl('GV_Tap_huan-3.jpg')"-->
                  <span class="icon-list mr-4"></span>
                  <div class="message-noti">
                    <span class="content font-size-14 primary_text_color">
                      <!-- <b class="primary-color-txt font-sanpro-semibold">{{ item.notificationName }}</b> -->
                      <!-- <br /> -->
                      {{ item.title }}
                      <span v-if="item.message !== null && item.isAuto">
                        <br />
                        <span v-html="item.message" class=""></span>
                      </span>
                      <span v-if="item.contentNotification !== '' && item.isAuto">
                        {{ item.contentNotification }}
                      </span>
                    </span>
                    <br />
                    <!-- <span class="secondary_text_color font-size-14" v-if="item.notificationTypeId ==1">{{ moment(item.createAt).format('HH:mm - DD/MM/YYYY') }}</span> -->
                    <span class="secondary-color-txt font-size-14">{{ moment(item.sendDate).format('HH:mm - DD/MM/YYYY')
                      }}</span>
                  </div>
                </div>
              </vue-custom-scrollbar>

              <a @click="nextPage" href="javascript:;"
                class="display-block text-center text-right primary-color font-size-15 mt-2 view-all">Xem tất cả</a>

            </template>
            <p v-else class="font-size-15 secondary-color-txt text-center margin-0">Không có thông báo nào!</p>
          </b-collapse>
        </div>
        <div class="header__direct position-rel" v-click-outside="hidenCollapseDirectPlatform">
          <a href="javascript:;" class="icon-header-circle border-rd-50 display-flex-center justify-content-center"
            :class="{ 'bg-color-hover': openCollapseNavPlatform }" @click="toggleCollapseDirectPlatform">
            <i class="icon-all secondary-color-txt"></i>
          </a>
          <b-collapse id="nav_direct" class="collapse border-rd-8 bg-color-light" :visible="openCollapseNavPlatform"
            @show="() => openCollapseNavPlatform = true" @hidden="() => openCollapseNavPlatform = false">
            <ul class="margin-0 text-center display-flex-center justify-content-between">
              <li>
                <a href="javascript:;" class="primary-color">
                  <img src="@/assets/images/logo4dots.png" alt="Hành trang số">
                  <p class="content font-size-14 margin-0 primary-color">Hành trang số</p>
                </a>
              </li>
              <li>
                <a href="http://taphuan.nxbgd.vn" target="_blank">
                  <img src="@/assets/images/logo4dots.png" alt="Hành trang số">
                  <p class="content font-size-14 margin-0">Tập huấn</p>
                </a>
              </li>
            </ul>
          </b-collapse>
        </div>
        <div class="header__direct position-rel" v-click-outside="hidenFormActive">
          <a href="javascript:;" class="icon-header-circle text-center border-rd-50"
            :class="{ 'bg-color-hover': isShowActiveCode }" @click="toggleFormActive">
            <i class="icon-key secondary-color-txt"></i>
          </a>
          <b-collapse id="panel_active_book" class="collapse border-rd-8 bg-color-light" :visible="openCollapseActive"
            @show="() => isShowActiveCode = true" @hidden="() => isShowActiveCode = false">
            <ActiveCode :previewBook="true" :isAccExperience="authInfo && authInfo.email === emailPublic"
              @activeSuccess="() => $root.$emit('bv::toggle::collapse', 'panel_active_book')" />
          </b-collapse>
        </div>
        <div class="header__user position-rel">
          <a v-if="authInfo && authInfo.email === emailPublic && !isLoginkeyCloak" href="javascript:;"
            class="primary-color font-size-16 font-sanpro-semibold border-rd-20 display-flex-center"
            style="padding: 0 20px;" @click="openLoginForm">Đăng nhập</a>
          <a v-if="authInfo && authInfo.email === emailPublic && isLoginkeyCloak" href="javascript:;"
            class="primary-color font-size-16 font-sanpro-semibold border-rd-20 display-flex-center"
            style="padding: 0 20px;" @click="onLoginSSOKeyCloak">Đăng nhập SSO</a>
          <a v-if="authInfo && authInfo.email === emailPublic" href="javascript:;"
            class="btn btn-main-light font-size-16 font-sanpro-semibold border-rd-20 display-flex-center"
            style="padding: 0 20px;" v-b-modal.modalRegister>Đăng ký</a>
          <!-- @click="logout(true)" -->
          <a v-else href="javascript:;" class="icon-user-account" v-click-outside="hidenFormAuth"
            @click="toggleFormAuth">
            <img class="users icon-toggle border-rd-50 p-0"
              :src="authInfo && authInfo.avatar ? `${uploadUrl}${authInfo.avatar}` : imgAvatar" alt="User" />
            <!-- <img class="users icon-toggle border-rd-50" src="@/assets/images/HS-2.jpg" alt="User"> -->
          </a>
          <b-collapse id="nav_user" class="collapse" :visible="openCollapseAuth">
            <ul class="margin-0 p-0 text-center">
              <li>
                <a href="javascript:void(0)" class="item" @click="userProfile">Trang cá nhân</a>
              </li>
              <!-- <li>		      					
		      					<router-link to="/" class="item">Cài đặt</router-link>
		      				</li>
		      				<li>		      					
		      					<router-link to="/" class="item">Trung tâm trợ giúp</router-link>
              </li>-->
              <li>
                <a href="javascript:;" @click="logout">Đăng xuất</a>
              </li>
            </ul>
          </b-collapse>
        </div>
        <button class="header__btn-menu display-flex-center justify-content-center border-0 border-rd-50"
          @click="toggleMenuMobile" :class="{ 'active': isMenuMobileOpen }">
          <i class="icon-category font-size-26"></i>
        </button>
      </div>
    </b-navbar>
    <ModalNotiDetail :dataSource="notificationSingle" v-if="this.$route.name != 'ViewNoticeAll'" />
    <modalNotify />

    <ModalSendDocument @closeModal="closeModalDocument" :id="idDocument" v-if="isShowModalSendDocument" />
  </header>
</template>

<script>
const signalR = require("@aspnet/signalr");
import { ID_MODAL_NOTIFY } from '@/store/common/constants'
import { mapActions, mapState } from "vuex";
import { APP_CONFIG } from "@/utils/constants";
import { getAuth } from "@/utils/jwt";
import { EMAIL_PUBLIC, ROLE_TEACHER, ROLE_PUPIL } from "@/store/auth/constants";
import ClickOutside from "vue-click-outside";
import vueCustomScrollbar from "vue-custom-scrollbar";
import ModalNotiDetail from "@/components/modal/ModalNotiDetail.vue";
import moment from "moment";
// import { HubConnectionBuilder, LogLevel } from "@aspnet/signalr";
import { fetchNotification, readNotification } from "@/store/common/api";
const imgAvatar = require("@/assets/images/HS-2.jpg");
import modalNotify from "@/components/modal/modalNotify.vue"
import HttpService from "@/utils/httpData"
import ModalSendDocument from './../../src/modules/class-school/_components/ModalSendDocument'
export default {
  name: "Header",
  directives: {
    ClickOutside
  },
  data() {
    return {
      isShowModalSendDocument: false,
      idDocument: 0,
      numberNotify: 0,
      cdnUrl: APP_CONFIG.cdnUrl,
      uploadUrl: APP_CONFIG.uploadUrl,
      imgAvatar,
      hidenHeader: false,
      listUrlActiveTabClass: ['/lop-hoc', '/quan-ly-lop-hoc', '/lop-hoc-cua-toi', '/danh-sach-lop-hoc'],
      listUrlActiveTabPrepare: ['/soan-tai-lieu', '/bai-giang-dien-tu-da-giao', '/kho-bai-giang/bai-giang-dien-tu', '/ke-hoach-da-giao', '/kho-ke-hoach-bay-day/ke-hoach-bai-day'],
      navigations: [
        {
          label: "Sách điện tử",
          route: {
            name: "ebook",
          },
          imageUrl: "@/assets/img/book-icon.png",
        },
        {
          label: "Luyện tập",
          route: {
            name: "exercise",
          },
          imageUrl: "@/assets/images/book-icon.png",
        },
        {
          label: "Thư viện",
          route: {
            name: "library",
          },
          imageUrl: "@/assets/images/library-icon.png",
        },
        {
          label: "Đề thi",
          route: {
            name: "exam-list",
          },
          imageUrl: "/assets/images/book-icon.png",
        },
        {
          label: "Lớp học",
          route: "#",
          imageUrl: "/assets/images/book-icon.png",
        },
        {
          label: "Hỏi đáp",
          route: {
            name: "discussion-list",
          },
          imageUrl: "/assets/images/book-icon.png",
        },
      ],
      isMenuMobileOpen: false,
      isShowActiveCode: false,
      isShowNotify: false,
      emailPublic: EMAIL_PUBLIC,
      roleTeacher: ROLE_TEACHER,
      roleHocSinh: ROLE_PUPIL,
      authInfo: {},
      openCollapseActive: false,
      openCollapseAuth: false,
      openCollapseNoti: false,
      notificationData: [],
      notificationSingle: {},
      arraySlide: [],
      openCollapseNavPlatform: false,
      configKeyclock: {},
      isLoginkeyCloak: true
    };
  },
  components: {
    // ModalNotiDetail: () => import("@/components/modal/ModalNotiDetail.vue"),
    modalNotify,
    ModalNotiDetail,
    vueCustomScrollbar,
    ModalSendDocument,
    ActiveCode: () => import("@/modules/ebooks/_components/common/ActiveCode.vue")
  },
  computed: {
    ...mapState("auth", ["isLoggedIn", "user", "loginPopupData"]),
    ...mapState("common", ["getCountNotifiNotRed", "getPramDisplay", "isShowModalNotify", 'isShowModalActive']),
    screenMobile() {
      return window.innerWidth > 991 ? false : true;
    }
    // authInfo() {
    // 	return getAuth();
    // }
  },

  watch: {
    isShowModalNotify(newVal) {
      if (newVal) {
        this.$bvModal.show(ID_MODAL_NOTIFY)
      }
    },
    $route: "checkDisplayHeader",
    loginPopupData(newVal) {
      if (newVal && Object.keys(newVal).length) this.authInfo = newVal;
    },
    getCountNotifiNotRed(newVal) {
      this.numberNotify = newVal;
    },
    getPramDisplay() {
      if (!this.$route.path.includes('mobile') && this.authInfo && this.authInfo.email && this.authInfo.email !== EMAIL_PUBLIC) {
        this.getNotification()
        let self = this
        fetchNotification({ notificationTypeId: 0, keyword: "", pageIndex: 1, pageSize: 10, sort: "", direction: "" }).then((res) => {
          if (res && res.data && !res.errors) {
            self.notificationData = res.data.list;
          }
        })
      }
    },

    user(newVal) {
      if (newVal) {
        this.authInfo = getAuth()
      }
    }
  },
  created() {

    this.checkDisplayHeader();

    if (!this.$route.path.includes('mobile')) {
      this.authInfo = getAuth();
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(`${APP_CONFIG.signalRUrl}message-hub`)
        .configureLogging(signalR.LogLevel.Information)
        .build();

      this.connection
        .start({ transport: "longPolling" })
        .then(() => {
          this.ready = true; // toggle ready flag here
        })
        .catch((err) => {
          console.error(err.toString());
        });
    }

  },
  async mounted() {

    if (!this.$route.path.includes('mobile')) {
      this.acToggleModalShowNotify(false)
      let self = this;
      if (this.authInfo && this.authInfo.email && this.authInfo.email !== EMAIL_PUBLIC) {
        this.connection.on("ReceiveMessage", function () {
          self.getNotification();
        });
      }
    }
    const request = await fetch(APP_CONFIG.dataUrl + "IsLoginkeyCloak");
    const response = await request.json();
    this.configKeyclock = response
    if (this.configKeyclock.isLoginKeyClock == 0) {
      this.isLoginkeyCloak = false;
    }
    else {
      this.isLoginkeyCloak = true;
    }
  },
  methods: {
    ...mapActions("auth", ["authLogout", "setAccFreeLogout", "setToggleLoginForm"]),
    ...mapActions("common", [
      "setIdActiveBookInHeader",
      "acToggleModalActiveBook",
      "actionCountNotificationNotRead",
      "setDataDetailNotifi",
      "actionCheckSlideActiveBook",
      "actionCheckArraySlide",
      "acToggleModalShowNotify",
      "actionSetDataModalNoti"
    ]),
    moment,
    checkActiveClass() {
      //lấy ra url hiện tại
      for (let i = 0; i < this.listUrlActiveTabClass.length; i++) {
        if (this.$route.path === this.listUrlActiveTabClass[i]) {
          return true
        }
      }
      return false
    },
    checkActivePrepare() {
      //lấy ra url hiện tại
      for (let i = 0; i < this.listUrlActiveTabPrepare.length; i++) {
        if (this.$route.path === this.listUrlActiveTabPrepare[i]) {
          return true
        }
      }
      return false
    },

    closeModalDocument() {
      this.isShowModalSendDocument = false
    },
    onLoginSSOKeyCloak() {
      const pageUrl = window.location.href.replace('&', 'th98th');
      window.location.href = this.configKeyclock.urlServerKeyCloak + "/realms/" + this.configKeyclock.realm + "/protocol/openid-connect/auth?response_type=code&client_id=" + this.configKeyclock.audience + "&redirect_uri=" + window.location.origin + this.configKeyclock.redirect + '?urlReturn=' + pageUrl
    },
    openLoginForm() {
      this.setToggleLoginForm(true);
    },

    logout() {
      if (this.isLoginkeyCloak) {
        let refresh_token = '';
        if (localStorage.getItem('refresh_token') != null) {
          refresh_token = localStorage.getItem('refresh_token')
        }
        let apiEndpoint = `Log-out?refresh_token=` + refresh_token;
        HttpService.get(apiEndpoint).then(() => {
          this.$root.$emit("bv::toggle::collapse", "nav_user");
          // isUserFree && this.setAccFreeLogout(true);
          this.authLogout();
        })
      }
      else {
        this.$root.$emit("bv::toggle::collapse", "nav_user");
        // isUserFree && this.setAccFreeLogout(true);
        this.authLogout();
      }

    },
    checkDisplayHeader() {
      this.openCollapseNoti = false
      this.hidenHeader = this.$route.meta.hideHeader ? true : false;
      this.getNotification();
      if (this.screenMobile) {
        this.isMenuMobileOpen = false;
      }
      // Allway hidden nav direct collapse
      this.$root.$emit("bv::toggle::state", ("panel_active_book", false));
    },
    getNotification() {
      let self = this;
      if (self.authInfo && self.authInfo.email && self.authInfo.email !== EMAIL_PUBLIC) {
        self.actionCountNotificationNotRead().then((res) => {
          if (res && res.data && !res.errors) {
            self.numberNotify = res.data.data;
          }
        });
      }
    },

    toggleMenuMobile() {
      this.isMenuMobileOpen = !this.isMenuMobileOpen;
    },
    userProfile(evt) {
      evt.preventDefault();
      this.$root.$emit("bv::toggle::collapse", "nav_user");
      this.$router.push({ name: "user-profile" });
      // Toggle mobile menu
      this.toggleMenuMobile();
    },

    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    extoverlay() {
      this.openCollapseNoti = false
    },
    toggleFormActive() {
      if (this.authInfo.email === EMAIL_PUBLIC) {
        this.openCollapseActive = !this.openCollapseActive;
      } else {
        this.acToggleModalActiveBook(true);
        // console.log('haha vao');
        // this.actionCheckSlideActiveBook({isShowSlide: true})
        // this.arraySlide = [
        //     {id: 1, src: require('@/assets/img/HDKH1.png')},
        //     {id: 2, src: require('@/assets/img/HDKH2.png')},
        //     {id: 3, src: require('@/assets/img/HDKH3.png')}
        // ]
        // this.actionCheckArraySlide(this.arraySlide)
      }
      // this.$root.$emit('bv::toggle::collapse', 'panel_active_book');
    },

    hidenFormActive() {
      this.openCollapseActive = false;
    },

    toggleFormAuth() {
      this.openCollapseAuth = !this.openCollapseAuth;
      this.$root.$emit("bv::toggle::collapse", "nav_user");
    },

    hidenFormAuth() {
      this.openCollapseAuth = false;
    },
    hidenCollapseNoti() {
      if (window.innerWidth > 992) {
        this.openCollapseNoti = false;
      }
      // 
    },

    handleActiveBookSuccess(val) {
      this.setIdActiveBookInHeader(val);
    },

    directHomPage() {
      if (this.authInfo.email == EMAIL_PUBLIC) {
        this.authLogout();
      } else {
        this.$router.push({ path: "/" });
      }
    },

    toggleCollapseNoti() {
      this.openCollapseNoti = !this.openCollapseNoti;
      fetchNotification({
        keyword: "",
        notificationTypeId: 0,
        pageIndex: 1,
        pageSize: 10,
        sort: "",
        direction: "",
      }).then((res) => {
        if (res && res.data && !res.errors) {
          this.notificationData = res.data.list;
        }
      });
    },

    toggleCollapseDirectPlatform() {
      this.openCollapseNavPlatform = !this.openCollapseNavPlatform
    },

    hidenCollapseDirectPlatform() {
      this.openCollapseNavPlatform = false
    },

    nextPage() {
      this.$router.push({
        path: "/thong-bao",
      });
    },

    fixUrl(url) {
      // Kiểm tra nếu URL không bắt đầu bằng "https://"
      if (!url.startsWith("https://")) {
        // Thêm "https://" vào đầu URL
        url = "https://" + url;
      }

      return url;
    },

    showInfoNoti(val, index) {
      let self = this;
      if (val.status && val.status == 2) {
        this.idDocument = val.id
        this.isShowModalSendDocument = true
        return
      }
      else if (val.status && val.status == 1) {

        this.idDocument = val.id
        this.isShowModalSendDocument = true
        return
      }

      if (val.url === '/thu-vien') {
        this.acToggleModalActiveBook(true)
      } else {
        this.acToggleModalActiveBook(false)
      }
      if (val.isAuto === false) {
        this.acToggleModalShowNotify(true)
        this.actionSetDataModalNoti(val)

      }

      if (val.url && val.url != null && val.isAuto) {
        let routeName = val.url.replace(`${window.location.origin}`, "")
        // console.log("routeName",routeName);
        if (this.$route.path.toString() != routeName.toString()) {
          self.$router.push({ path: `${routeName}` })
        }
      }
      if (val && val.notificationId && !val.isReaded) {
        readNotification(val.notificationId).then((res) => {
          if (res && !res.errors) {
            self.getNotification()
            self.notificationData[index]["isReaded"] = true;
          }
        });
        // self.notificationSingle = val;
        self.setDataDetailNotifi(val);

        // console.log(" self.notificationSingle", self.notificationSingle);
        // self.$bvModal.show(MODAL_ID_REQ_INFO_DETAIL);
      }

      // fetchNotification(values).then(res => {
      // 	if(res && res.data && !res.errors) {
      // 			self.notificationData = res.data.list;
      // 		}
      // })
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay_notifi {
  position: fixed;
  /* Sit on top of the page content */
  display: block;
  /* Hidden by default */
  width: 100%;
  /* Full width (cover the whole page) */
  height: 100%;
  /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* Black background with opacity */
  z-index: 0;
  /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer;
  /* Add a pointer on hover */
  opacity: 0;
}

// .header__notification__collaspe{
//     overflow-x: hidden !important;
//     overflow: scroll !important;
// }
#alert_notification {
  // overflow-anchor: none;
  //   overflow-y: scroll;
  //   -webkit-overflow-scrolling:touch; // mobile safari
  //   touch-action: auto;
  //   touch-action: pan-up;
  //   touch-action: pan-down;
  //   @media screen and (max-width: 575px){
  //     overflow-y: scroll;
  //     -webkit-overflow-scrolling:touch; // mobile safari
  //     touch-action: auto;
  //  }
}

.message-noti {
  p {
    margin: 0 !important;
  }
}

.white-space {
  white-space: pre-wrap !important;
}

.header {
  position: fixed;
  z-index: 2;

  &__notification {
    // margin-left: 35px;
    z-index: 1;

    &__dot {
      position: absolute;
      right: 1px;
      width: 19px;
      height: 19px;
      // display: block;
      @extend .position-center-y;
      @extend .border-rd-50;
      background: $color_err;
      margin-top: -11px;
      pointer-events: none;
      justify-content: center;
      display: flex;
      flex-direction: center;
      align-items: center;
      font-size: 9px;
      color: #fff;

      .ping {
        border: 1px solid $color_err;
        width: 8px;
        height: 8px;
        opacity: 1;
        background-color: rgba($color_err, 0.5);
        border-radius: 100%;
        -moz-animation: sonar 1.25s linear infinite;
        -o-animation: sonar 1.25s linear infinite;
        -webkit-animation: sonar 1.25s linear infinite;
        animation: sonar 1.25s linear infinite;
        display: block;
      }
    }

    &__collaspe {
      max-height: 400px;
      overflow-x: hidden;
      overflow: scroll;
    }
  }

  .navbar {
    .header__notification {
      position: relative;
    }

    .icon-user-account {
      width: 40px;
      height: 40px;

      img {
        // max-width: 100%;
        height: 40px;
        width: 40px;
        border: 1px solid $color_border_main;
      }
    }

    #panel_active_book {
      position: absolute;
      right: -65px;
      top: 100%;
      z-index: 9;
    }

    .icon-header-circle {
      width: 35px;
      height: 35px;
      line-height: 35px;
    }

    #alert_notification,
    #transform,
    #nav_user,
    #switchPlatform {
      position: absolute;
      top: 100%;
      right: 0;
      @extend .bg-color-light;
      @extend .box-shadow-main;
      @extend .border-rd-4;
      z-index: 2;
    }

    .icon-toggle {
      line-height: 60px;
      padding: 0 10px;
      cursor: pointer;

      &.active {
        &:before {
          content: "";
          width: 40px;
          height: 40px;
          display: block;
          position: absolute;
          top: 0;
          background: $btn_hover_color;
          z-index: -1;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          @extend .border-rd-50;
          margin: 0 auto;
        }
      }
    }

    #alert_notification {
      width: 335px;
      padding: 10px 0;
      z-index: 11;

      .background-isRead {
        background: #E1EFFF;
      }

      .item {
        padding: 10px;
        border-bottom: 1px solid #f1f1f1;
        cursor: pointer;

        img {
          width: 30px;
          height: 30px;
          @extend .border-rd-50;
          margin-right: 15px;
        }

        .content {
          @extend .font-size-14;
          color: #40505e;
        }

        &:hover {
          // @extend .bg-color-hover;
        }

        &:not(:last-child) {
          // border-bottom: 1px solid #d1d1d1;
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .header .navbar {

    #panel_active_book {
      right: 0;
    }
  }
}

@media screen and (max-width: 575px) {
  .view-all {
    font-size: 15px !important;
  }
}
</style>